if (!customElements.get('piecework-header')) {
  customElements.define(
    'piecework-header',
    class PieceworkHeader extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          simpleItems: this.querySelectorAll('.pw-nav-item-simple'),
          complexItems: this.querySelectorAll('.pw-nav-item-complex'),
          hamburger: this.querySelector('#mobile-menu-toggle'),
          navContainer: this.querySelector('.nav-container'),
          headerContainer: this.querySelector('#header-container'),
        };

        this.navOpen = false;
        this.mouseOver = false;

        this.elements.complexItems?.forEach((item, i) => {
          const itemLink = item.querySelector('.nav-complex-button');
          const back = item.querySelector('.nav-complex-back');

          const colors = {
            bg: itemLink.dataset.bg,
            text: itemLink.dataset.text,
            bga: itemLink.dataset.bga,
            texta: itemLink.dataset.texta,
            border: itemLink.dataset.border,
          };
          item.classList.add('tw-group/nav-item');

          itemLink.addEventListener('click', this.toggleSubnav.bind(this, colors, item));
          back.addEventListener('click', this.toggleSubnav.bind(this, colors, item));
          if (window.matchMedia('(pointer: fine)').matches) {
            item.addEventListener('mouseenter', this.setHoverState.bind(this, colors));
            item.addEventListener('mouseleave', this.removeHoverState.bind(this));
          }
        });

        this.elements.hamburger.addEventListener('click', () => {
          this.toggleNav();
        });

        window.addEventListener('resize', this.setHeaderHeight.bind(this));
      }

      toggleNav() {
        if (this.classList.contains('nav-open')) {
          this.closeNav();
        } else {
          this.openNav();
        }
      }

      openNav() {
        this.classList.add('nav-open');
        document.body.classList.add('tw-overflow-hidden');
        this.elements.hamburger.classList.add('open');
        this.elements.hamburger.querySelector('.tw-sr-only').innerHTML = 'Close the Menu';
        this.navOpen = true;
      }

      closeNav() {
        this.classList.remove('nav-open');
        document.body.classList.remove('tw-overflow-hidden');

        this.elements.complexItems?.forEach((item, i) => {
          item.classList.remove('sub-nav-open');
          item.querySelector('.nav-complex-button').setAttribute('aria-expanded', 'false');
        });
        this.elements.hamburger.classList.remove('open');
        this.elements.hamburger.querySelector('.tw-sr-only').innerHTML = 'Open the Menu';
        this.navOpen = false;
        this.classList.remove('nav-complex-open');
        this.removeColors();
        this.classList.remove('nav-colors');
      }

      connectedCallback() {
        this.setHeaderHeight();
      }

      setHeaderHeight() {
        const box = this.elements.headerContainer.getBoundingClientRect();
        document.documentElement.style.setProperty('--header-height', `${box.height - 1}px`);
      }

      toggleSubnav(colors, item) {
        this.elements.complexItems?.forEach((nav, i) => {
          if (nav !== item) {
            nav.classList.remove('sub-nav-open');
            nav.querySelector('.nav-complex-button').setAttribute('aria-expanded', 'false');
          }
        });
        if (item.classList.contains('sub-nav-open')) {
          // if (!this.mouseOver) {
          //   this.removeColors();
          // }
          if (window.matchMedia('(max-width: 990px)').matches) {
            setTimeout(() => {
              this.classList.remove('nav-complex-open');
              this.removeColors();
              this.classList.remove('nav-colors');
              // this.navOpen = true;
            }, 500);
          } else {
            this.classList.remove('nav-complex-open');
            this.removeColors();
            this.classList.remove('nav-open');
            this.classList.remove('nav-colors');
          }
          this.navOpen = true;
          // this.removeColors();
          item.classList.remove('sub-nav-open');
          item.querySelector('.nav-complex-button').setAttribute('aria-expanded', 'false');
        } else {
          this.navOpen = true;
          this.classList.add('nav-complex-open');
          this.classList.add('nav-colors');
          this.setColors(colors);
          item.classList.add('sub-nav-open');
          item.querySelector('.nav-complex-button').setAttribute('aria-expanded', true);
        }
      }

      setColors(colors) {
        this.style.setProperty('--bg', colors.bg);
        this.style.setProperty('--bga', colors.bga);
        this.style.setProperty('--text', colors.text);
        this.style.setProperty('--texta', colors.texta);
        this.style.setProperty('--border', colors.border);
      }

      removeColors() {
        this.style.setProperty('--bg', null);
        this.style.setProperty('--bga', null);
        this.style.setProperty('--text', null);
        this.style.setProperty('--texta', null);
        this.style.setProperty('--border', null);
      }

      removeHoverState() {
        if (window.matchMedia('(pointer: fine)').matches) {
          this.mouseOver = false;
          this.classList.remove('nav-complex-open');
          this.classList.remove('nav-colors');
          this.removeColors();
          this.closeNav();
        }
      }

      setHoverState(colors) {
        if (window.matchMedia('(pointer: fine)').matches) {
          this.mouseOver = true;

          this.classList.add('nav-complex-open');
          this.classList.add('nav-colors');
          this.setColors(colors);
        }
      }
    }
  );
}
